module.exports = require('./SchoolList');